<!--
  * @Author: jh 1758579481@qq.com
  * @Date: 2021/2/25
-->
<template>
  <div>
    <div style="font-size: .28rem;" v-if="answers.length>0">
      <div class="van-cell van-field">
        <div class="van-cell__title van-field__label">
          <span>姓名</span>
        </div>
        <div class="van-cell__value van-field__value">
          <div class="van-field__body">
            <input type="text" name="name" v-model="answers[0].name" readonly="readonly" class="van-field__control"></input>
          </div>
        </div>
      </div>
      <div class="van-cell van-field">
        <div class="van-cell__title van-field__label">
          <span>住址</span>
        </div>
        <div class="van-cell__value van-field__value">
          <div class="van-field__body">
            <input type="text" name="address" v-model="answers[0].address" readonly="readonly" class="van-field__control"></input>
          </div>
        </div>
      </div>
      <div class="van-cell van-field">
        <div class="van-cell__title van-field__label">
          <span>身份证号码</span>
        </div>
        <div class="van-cell__value van-field__value">
          <div class="van-field__body">
            <input type="text" name="idCard" v-model="answers[0].idCard" readonly="readonly" class="van-field__control"></input>
          </div>
        </div>
      </div>
      <div class="van-cell van-field">
        <div class="van-cell__title van-field__label">
          <span>联系电话</span>
        </div>
        <div class="van-cell__value van-field__value">
          <div class="van-field__body">
            <input type="text" name="phone" v-model="answers[0].phone" readonly="readonly" class="van-field__control"></input>
          </div>
        </div>
      </div>
      <div v-for="(item,index) in questions" :key="index" class="question_list">
        <div class="question_title">{{(item.sort+1)+'.'+item.question}}<span style="color: red;">*</span></div>
        <div v-for="(item1,index1) in item.result.split(';')" :key="index1" @click="bindRadio(item1,index)">
          <el-radio :label="item1" :value="radioValue[index]" border class="question_radio"></el-radio>
        </div>
        <div v-show="item.sort==6 && showInput">
          <el-input
            style="display: block!important;"
            placeholder="请输入具体地区"
            v-model="formAddress"
            clearable>
          </el-input>
        </div>
      </div>
      <div style="width: 100%;height: .8rem"></div>
      <div style="width: 100%;text-align: center;padding-bottom: 1rem;">
        <el-button type="success" round size="medium" style="width: 80%;font-size: .3rem;color: #ffffff;" @click="subForm">修改问卷</el-button>
      </div>
    </div>
    <div class="noCard" v-if="!answers.length>0">
      <div class="noCard-img">
        <img src="static/img/noCard.png"/>
      </div>
      <div class="noCard-text">暂无数据</div>
    </div>
  </div>
</template>

<script>
  import {gethisCrownresultDetail, Savehiscrownresult} from '../../api/index'
  export default {
    name: "answerDetails",
    data() {
      return {
        answers:[],
        questions:[
          {sort:0,question:'你是否有发热、咳嗽等呼吸道症状？',result:'是;否'},
          {sort:1,question:'近21天是否去过国外、港澳台或其他国内重点地区，或有病例报告的社区？',result:'是;否'},
          {sort:2,question:'近21天内是否接触过来自国外、港澳台或其他国内重点地区的发热或有呼吸道症状的患者？',result:'是;否'},
          {sort:3,question:'近21天内是否与新型冠状病毒感染者（核酸检测阳性者）有接触？',result:'是;否'},
          {sort:4,question:'近21天内您的家庭或办公室等小范围内是否出现2例及以上发热和/或呼吸道症状的病例？',result:'是;否'},
          {sort:5,question:'粤康码',result:'绿码;红码;无法提供'},
          {sort:6,question:'您21天内从哪个地区来蕉岭？',result:'一直在蕉岭;国内（请在下方注明具体省市县）;香港;澳门;台湾;国外（请在下方注明具体国家或地区）'},
        ],
        radioValue:[],
        formAddress:'',
        results:[],
        showInput:false
      }
    },
    created() {
      //修改标题
      document.title = '新冠问卷答案详情'
      this.gethisCrownresultDetail()
    },
    methods: {
      gethisCrownresultDetail(){
        const loading = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
        gethisCrownresultDetail({
          strOpenid:this.$storage.get('openid'),
          strdate:this.$route.query.time,
          patientID:this.$route.query.patientId
        }).then(res=>{
          loading.close()
          if(res.IsSuccess){
            this.answers = res.Data
            if (res.Data[6].result == '国内（请在下方注明具体省市县）' || res.Data[6].result == '国外（请在下方注明具体国家或地区）') {
              this.showInput = true
            } else {
              this.showInput = false
            }
            res.Data.forEach(e=>{
              this.results.push({pid: e.pid, question: e.question, result: e.result})
            })
            this.formAddress = res.Data[6].formAddress
            this.radioValue = res.Data.map(x => {return x.result})
          }else {
            this.$message({
              type: 'error',
              message: res.Msg,
              duration:3000,
              offset:200
            });
          }
        })
      },
      bindRadio(item,index){
        if(this.radioValue[index] != item){
          this.$set(this.radioValue,index,item)
          if (index == 6) {
            if (item == '国内（请在下方注明具体省市县）' || item == '国外（请在下方注明具体国家或地区）') {
              this.showInput = true
            } else {
              this.showInput = false
            }
          }
          let find = this.results.findIndex((v) => {
            return v.pid == index
          })
          if (find > -1) {  //判断结果里是否有相同的id
            this.results = this.results.map(m => {
              return m.pid == index ? {pid: index, question: this.questions[index].question, result: item } : m
            })   //覆盖掉id相同的那条数据
          } else {
            this.results.push({pid: index, question: this.questions[index].question, result: item})
          }
        }
      },
      subForm(){
        if(!this.formAddress && this.showInput){
          this.$message({
            message: '请填写具体地区！',
            type: 'error',
            duration:3000,
            center:true,
            offset:200
          });
          return
        }
        Savehiscrownresult({
          createtime:this.$route.query.time,
          patient_id: this.$storage.get('patient').patient_id,
          name:this.answers[0].name,
          address:this.answers[0].address,
          idCard:this.answers[0].idCard,
          phone:this.answers[0].phone,
          result:this.results,
          formAddress: this.formAddress,
          openid:this.$storage.get('openid')
        }).then(res=>{
          if(res.IsSuccess){
            this.$message({
              message: '修改成功！',
              type: 'success',
              duration:3000,
              center:true,
              offset:200
            });
          }else {
            this.$message({
              message: '出错啦，请重试！',
              type: 'error',
              duration:3000,
              center:true,
              offset:200
            });
          }
        })
      }
    }
  }
</script>

<style scoped>
  @import "../../../static/css/vant.css";
  .question_list{
    width: 90%;
    margin: 0 auto;
  }
  .question_title{
    margin: .2rem 0;
    font-size: .32rem;
    font-weight: 700;
  }
  .question_radio{
    width: 100%;
    margin: 0.06rem 0;
  }
  .noCard{
    width: 7.5rem;
    height: 3.5rem;
    padding: 2rem 0 4rem 0;
    background-color: #ffffff;
    font-size: .28rem;
  }
  .noCard .noCard-img{
    width: 2.6rem;
    height: 2.6rem;
    margin: 0 auto;
  }
  .noCard .noCard-img img{
    width: 100%;
    height: 100%;
  }
  .noCard .noCard-text{
    margin-top: .3rem;
    font-size: .32rem;
    line-height: .32rem;
    width: 100%;
    height: .32rem;
    text-align: center;
    color: #999999;
  }
</style>



// WEBPACK FOOTER //
// src/components/pages/answerDetails.vue